enum StatusType {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  PENDING_REVIEW = "PENDING_REVIEW",
  INACTIVE = "INACTIVE",
  CLOSED = "CLOSED",
  FROZEN = "FROZEN",
  DEACTIVATED = "DEACTIVATED",
}

export default StatusType;
